export default "Aides Entreprises — CEE BAT/IND, Fonds Chaleur, décarbonation, suramortissement | Solution Éco France";
